<template>
  <div>
    <vx-card class="w-full mb-6">
      <vs-table ref="questionSARSTable" stripe class="vs-con-loading__container" single 
      @selected="handleSelected" pagination :max-items="itemsPerPage" search :data="sarsQuestions">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
          <div class="flex flex-wrap-reverse items-center">
            <!-- ADD NEW -->
            <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="showDetailsCard" >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="question">Question</vs-th>
          <vs-th sort-key="moduleName">Module</vs-th>
          <vs-th sort-key="frequencyName">Frequency</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="question" :key="indextr" v-for="(question, indextr) in data">

            <vs-td :data="data[indextr].question">
              {{ question.question }}
            </vs-td>
            <vs-td :data="data[indextr].moduleName">
              {{ question.moduleName ? question.moduleName : "N/A" }}
            </vs-td>
            <vs-td :data="data[indextr].frequencyName">
              <vs-chip :color="question.frequencyId == 1 ? 'warning' : 'success'">{{ question.frequencyName }}</vs-chip>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vx-card id="questionInfoCard" ref="questionInfo" class="mb-6" :title="cardTitle" v-show="!isInfoHidden">
      <div class="vx-row mb-3">
        <div class="vx-col sm:w-1/2 w-full">
          <label>Question</label>
          <vs-textarea autocomplete="off" onClick="this.select();" class="w-full" v-model="formData.question" />
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <label>LP Name <small>(optional)</small></label>
          <v-select
              ref="moduleDropdown"
              class="w-full style-chooser"
              placeholder="Search / Select LP"
              :options="moduleList"
              v-model="moduleDropdown"
          >
          </v-select>
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <span v-if="moduleDropdown">This question will need to be answered <strong>upon completion of the LP</strong></span>
          <span v-else>This question will need to be answered <strong>weekly</strong></span>
        </div>
      </div>
      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" :disabled="isDisabled" @click.prevent="saveEditQuestion" ref="saveEditButton">Save</vs-button>
          <vs-button v-if="formData.id" color="danger"  class="mr-5 mb-2 vs-con-loading__container" @click.prevent="deleteQuestion" ref="deleteButton">Delete</vs-button>
          <vs-button color="warning" type="border" class="mb-2" @click="cancelAdd">Cancel</vs-button>
        </div>
      </div>
    </vx-card>

  </div>
</template>

<script>

import vSelect from 'vue-select'

  export default {
    components: {
      'v-select': vSelect
    },
    data() {
      return {
        loadingColor:'#fff',
        selected: [],
        itemsPerPage: 10,
        isMounted: false,
        isInfoHidden: true,
        sarsQuestions: [],
        formData: {
          id: 0,
          question: "",
          moduleId: 0,
          frequencyId: 0
        },
        moduleDropdown: 0,
        moduleList: [],
        mode: "",
        cardTitle: ""
      }
    },
    computed: {
      isDisabled: function() {
        return !(this.formData.question);
      }
    },
    methods: {
      initValues() {
        this.mode = "";
        this.moduleDropdown = "";
        this.isInfoHidden = true;
        this.formData.id = 0;
        this.formData.question = "";
        this.formData.moduleId = 0;
        this.formData.frequencyId = 0;
      },
      getModules(){
        var self = this;

        var onSuccess = response=>{
          var tempModules = response.data.map(x=>{
            return{label: x.text, value: x.value}
          });

          self.moduleList = tempModules.sort((a, b) =>
            a.label > b.label ? 1 : -1
          );

          self.moduleList = Array.from(new Set(self.moduleList.map(x => x.value)))
            .map(value => {return{label: self.moduleList.find(x => x.value == value).label,
                                  value: value}});
        };
        self.$ajaxGet(self, "Module/GetAllModulesWithCourseName", onSuccess);
      },
      cancelAdd() {
        this.initValues();
        this.isInfoHidden = true;
      },
      loadData() {
        var self = this;
        self.showLoadingOnElement("questionSARSTable", 1, "corners");

        var onSuccess = function (response) {
          self.sarsQuestions = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.questionSARSTable.$el);
        };
        self.$ajaxGet(self, "SonkeSARSQuestion/ListQuestions", onSuccess, onFinally);
      },
      showDetailsCard(){
        var self = this;
        self.initValues();
        self.getModules();
        self.isInfoHidden = false;
        self.mode = "Add New";
        self.cardTitle = "Create New Question";
      },
      handleSelected(tr) {
        var self = this;
        self.getModules();
        self.isInfoHidden = false;
        self.mode = "Update";
        self.cardTitle = "Edit Question";

        self.formData.id = tr.id;
        self.formData.question = tr.question;
        self.formData.frequencyId = tr.frequencyId;
        self.moduleDropdown = self.moduleList.filter(function(item){
          return item.value == tr.moduleId;
        })[0];
      },
      saveEditQuestion() {
        var self = this;
        self.showLoadingOnElement("saveEditButton", 0.45, "material");

        var onSuccess = response => {
          this.initValues();
          this.loadData();
          this.$vs.loading.close(this.$refs.saveEditButton.$el);
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Question Saved",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-save'
          });
        }
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.saveEditButton.$el);  
        };

        self.formData.moduleId = self.moduleDropdown ? parseInt(self.moduleDropdown.value) : null;
        self.formData.frequencyId = self.moduleDropdown ? 1 : 2;

        self.$ajaxPost(self, "SonkeSARSQuestion/AddEdit", self.formData, onSuccess, onFinally);   
      },
      deleteQuestion() {
        var self = this;
        self.showLoadingOnElement("deleteButton", 0.45, "material");

        var onSuccess = response => {
          self.initValues();
          self.loadData();
          self.scrollToNavbar();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Question Deleted",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.deleteButton.$el);
        };
        self.formData.id = parseInt(self.formData.id);
        self.$ajaxGet(self, "SonkeSARSQuestion/Delete?id=" + self.formData.id, onSuccess, onFinally);
      },
      showLoadingOnElement(element, scale, type){
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
    },
    mounted() {
      var self = this;
      self.getModules();
      self.loadData();
      self.isMounted = true;
    },
  }

</script>